
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
:host {
  font-family: var(--slh-default-font-family, "Open Sans");
  display: inline-flex;
  vertical-align: top;
  text-transform: uppercase;
  fill: var(--slh-color-neutral-shade-40, #C0C8D8);
}
:host .slh-nav-avatar {
  display: inline-flex;
  font-size: var(--slh-base-xs-font-size, 14px);
}
:host .slh-nav-avatar slh-icon {
  outline: none;
  display: inline-flex;
}
:host .slh-nav-avatar .avatar {
  outline: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: var(--slh-base-bold-font-weight, 700);
  color: var(--slh-color-neutral-shade-00, #FFFFFF);
  width: 40px;
  height: 40px;
}
:host .slh-nav-avatar .avatar.avatar-image {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-color: transparent !important;
}
:host .slh-nav-avatar .avatar.small {
  width: 24px;
  height: 24px;
}

:host(:focus-visible) {
  position: relative;
  outline: none;
}
:host(:focus-visible)::after {
  content: "";
  display: block;
  border-radius: 50%;
  position: absolute;
  top: -2px;
  left: -2px;
  width: 100%;
  height: 100%;
  border: 2px solid var(--slh-color-outline, #4C49D4);
}
`;
